import { ReactNode, createContext, useState } from "react";

// Define the shape of the context data
interface ISelectedUserContextType {
  selectedUser: any;
  handleSelectedUser: (userData: any) => void;
  existingEnquiry: any;
  handleExistingEnquiry: (enquiry: any) => void,
  addRemoveCabinLoader: boolean,
  handleAddRemoveCabinLoader: (loaderState: boolean) => void,
  lastCabinUpdates: { lastCabinId: string, undo: boolean}
  handleLastCabinUpdates: (lastCabinId: string, undo: boolean) => void;
}

// Props for the SelectedUserProvider component
interface SelectedUserProviderProps {
  children: ReactNode;
}

// Initial state and function values
export const SelectedUserContext = createContext<ISelectedUserContextType>({
  selectedUser: { email: "", firstName: "", lastName: "", countryCode:"", phoneNumber: "", whatsappCountryCode:"", whatsappNumber: "", accountSource: "" },
  handleSelectedUser: () => {},
  existingEnquiry: {},
  handleExistingEnquiry: () => {},
  addRemoveCabinLoader: false,
  handleAddRemoveCabinLoader: () => { },
  lastCabinUpdates: { lastCabinId: "", undo: false },
  handleLastCabinUpdates: () => {}
});

export const SelectedUserProvider = ({ children }: SelectedUserProviderProps) => {
  // States to hold data
  const [selectedUser, setSelectedUser] = useState({});
  const [existingEnquiry, setExistingEnquiry] = useState({})
  const [addRemoveCabinLoader, setAddRemoveCabinLoader] = useState<boolean>(false);
  const [lastCabinUpdates, setLastCabinUpdates] = useState({ lastCabinId: "", undo: false });

  // Functions to set data
  const handleSelectedUser = (userData: any) => setSelectedUser(userData);
  const handleExistingEnquiry = (enquiry: any) => setExistingEnquiry(enquiry);
  const handleAddRemoveCabinLoader = (loaderState: any) => setAddRemoveCabinLoader(loaderState);
  const handleLastCabinUpdates = (lastCabinId: string, undo: boolean) => setLastCabinUpdates({ lastCabinId: lastCabinId, undo: undo });

  // States and functions which will be passed
  const contextValue: ISelectedUserContextType = {
    selectedUser,
    handleSelectedUser,
    existingEnquiry,
    handleExistingEnquiry,
    addRemoveCabinLoader,
    handleAddRemoveCabinLoader,
    lastCabinUpdates,
    handleLastCabinUpdates,
  };

  // Provide the context value to the children components
  return <SelectedUserContext.Provider value={contextValue}>{children}</SelectedUserContext.Provider>;
};
